import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';import './MenuPage.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import menuBgImage from '../../../../assets/menu-bg-image.png';

interface MenuItem {
  name: string;
  pdfUrl: string;
}

const MenuPage: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const menuItems: MenuItem[] = [
    { 
      name: t('restaurantMangle:menuMangle.labels.breakfast'), 
      pdfUrl: t('restaurantMangle:menuMangle.pdfUrlDesayunos') 
    },
    { 
      name: t('restaurantMangle:menuMangle.labels.lunch'), 
      pdfUrl: t('restaurantMangle:menuMangle.pdfUrlLunch') 
    },
    { 
      name: t('restaurantMangle:menuMangle.labels.dinner'), 
      pdfUrl: t('restaurantMangle:menuMangle.pdfUrlCenas') 
    },
    { 
      name: t('restaurantMangle:menuMangle.labels.wine'), 
      pdfUrl: t('restaurantMangle:menuMangle.pdfUrlVinos') 
    },
    { 
      name: t('restaurantMangle:menuMangle.labels.pizza'), 
      pdfUrl: t('restaurantMangle:menuMangle.pdfUrlPizza') 
    },
  ];

  return (
    <div className="menu-page-container">
      <div className="menu-options-column" data-aos="fade-right">
        <div className="menu-content-wrapper">
          <h2 className="menu-title" data-aos="fade-down" data-aos-delay="100">
            <Trans i18nKey="restaurantMangle:menuMangle.title" />
          </h2>
          <nav className="menu-list" data-aos="fade-up" data-aos-delay="200">
            <ul>
              {menuItems.map((item, index) => (
                <li key={index} data-aos="fade-left" data-aos-delay={300 + index * 100}>
                  {/* Validamos que si el pdfUrl es '#' no intente abrir nada o se comporte distinto */}
                  <a 
                    href={item.pdfUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className={item.pdfUrl === '#' ? 'disabled-link' : ''}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      <div className="menu-image-column" data-aos="fade-left">
        <img 
          src={menuBgImage} 
          alt={t('restaurantMangle:menuMangle.imageAlt')} 
          className="menu-image" 
        />
      </div>
    </div>
  );
};

export default MenuPage;